export default {
  products: null,
  featured: null,
  categories: null
}
